import $ from 'jquery';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Popover from '@material-ui/core/Popover';
import InfoIcon from '@material-ui/icons/Info';
import ENGINES, {
  coreToKNode,
  uniqueServers,
  showEngineInfo,
  showAnalizeButton
} from '../../../utils';

const styles = theme => ({
  root: {
    flexGrow: 1,
    marginTop: 20
  },
  card: {
    margin: 10,
    textAlign: 'center'
  },
  selServerInfoContainer: {
    width: '100%',
    textAlign: 'center',
    marginTop: 30
  },
  formControlLabel: {
    flexDirection: 'unset',
    margin: theme.spacing(0)
  },
  popover: {
    pointerEvents: 'none',
    width: '40%'
  },
  paper: {
    padding: theme.spacing(1),
    backgroundColor: '#FAEFB5'
  }
});

class EngineServers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      availableServers: [],
      availableServersIntervalId: null,
      pingAliveIntervalId: null,
      isOrdering: false,
      isStopping: false,
      orderedCores: null,
      isServerSyzygyOrdering: {}
    };
  }

  componentDidMount() {
    const { selectedEngineIndex } = this.props;

    this.getAvailableServers(selectedEngineIndex);
    this.pingAlive(ENGINES[selectedEngineIndex]);
  }

  componentWillUnmount() {
    const { availableServersIntervalId, pingAliveIntervalId } = this.state;

    clearInterval(availableServersIntervalId);
    clearInterval(pingAliveIntervalId);
    this.setState({
      availableServersIntervalId: null,
      pingAliveIntervalId: null
    });
  }

  pingAlive = engine => {
    const interval = setInterval(() => {
      $.ajax({
        url: `/api/ping_alive?engine=${engine}`,
        method: 'GET',
        success() {
          console.log('Pinged');
        }
      });
    }, 5000);

    this.setState({ pingAliveIntervalId: interval });
  };

  getAvailableServers = selectedEngineIndex => {
    const interval = setInterval(() => {
      $.ajax({
        url: '/api/available_servers',
        method: 'GET',
        success: response => {
          this.setState({
            availableServers: uniqueServers(selectedEngineIndex, response)
          });
        }
      });
    }, 3000);

    this.setState({ availableServersIntervalId: interval });
  };

  orderServer = (cores, engine) => {
    const { availableServersIntervalId, isServerSyzygyOrdering } = this.state;
    const { enginesOptionsList } = this.props;
    const options = enginesOptionsList[engine];

    this.setState({ isOrdering: true, orderedCores: cores });
    $.ajax({
      url: `/billing/order_server?cores=${cores}&engine=${engine}&options=${JSON.stringify(
        options
      )}&plugin=1`,
      method: 'GET',
      success: response => {
        if (response.error) {
          this.setState({ isOrdering: false });
          console.log('ERROR ORDERING');
          return;
        }
        clearInterval(availableServersIntervalId);
      },
      error: err => {
        this.setState({ isOrdering: false });
        console.log('IN CATCH', err);
      }
    });
    if (options.syzygy.options[0]) {
      isServerSyzygyOrdering[engine] = true;
      this.setState(isServerSyzygyOrdering);
      const deleteSyzygyOrderServer = engine => {
        setTimeout(() => {
          delete isServerSyzygyOrdering[engine];
          this.setState(isServerSyzygyOrdering);
        }, 25000);
      };
      deleteSyzygyOrderServer(engine);
    }
  };

  stopServer = engine => {
    const { selectedEngineIndex } = this.props;
    const { availableServersIntervalId } = this.state;

    this.setState({ isStopping: true });

    $.ajax({
      url: `/billing/stop_server?engine=${engine}`,
      method: 'GET',
      success: response => {
        if (response.error) {
          this.setState({ isStopping: false });
          console.log('ERROR STOPPING');
          return;
        }
        clearInterval(availableServersIntervalId);
        this.getAvailableServers(selectedEngineIndex);
      },
      error: err => {
        this.setState({ isStopping: false });
        console.log('IN CATCH', err);
      }
    });
  };

  orderIsDisabled = pricePerMinute => {
    // var currentBallance = this.state.balance;
    const currentBallance = 10000;
    return currentBallance <= pricePerMinute;
  };

  _renderPreparingServer = () => {
    const { classes } = this.props;
    return (
      <div className={classes.selServerInfoContainer}>
        <Typography variant="h6" gutterBottom>
          Preparing Server
        </Typography>
        <CircularProgress />
      </div>
    );
  };
  _renderSyzygyMessage = () => {
    const { classes } = this.props;
    const { isServerSyzygyOrdering } = this.state;
    return (
      <div className={classes.selServerInfoContainer}>
        <Typography variant="h6" gutterBottom>
          Loading the engine with Syzygy takes up to 10 seconds
        </Typography>
      </div>
    );
  };
  _renderOrderedServerInfo = () => {
    const { classes, selectedEngineIndex, user } = this.props;
    const { isStopping, orderedCores } = this.state;

    const engine = ENGINES[selectedEngineIndex];

    let serverEngineInfoText = `${coreToKNode(selectedEngineIndex, user.server.cores).average
      } kN/s server running ${engine}`;
    if (engine === 'stockfish10') {
      let engineName = 'Stockfish 17';
      serverEngineInfoText = `${coreToKNode(selectedEngineIndex, user.server.cores).average
        } kN/s server running ${engineName}`;
    }

    if (engine === 'lc0') {
      let engineName = 'LCZero';
      serverEngineInfoText = `GPU Cloud server running ${engineName}`;
    }
    let serverEngineInfo = (
      <Typography
        variant="h5"
        gutterBottom
      >{`You have rented a ${serverEngineInfoText}`}</Typography>
    );
    if (user.server.for_guests) {
      if (orderedCores === user.server.cores) {
        serverEngineInfo = (
          <Typography variant="h5" gutterBottom>
            {showEngineInfo('free')}
          </Typography>
        );
      } else {
        serverEngineInfo = (
          <Typography variant="h5" gutterBottom>
            {showEngineInfo(user.status)}
          </Typography>
        );
      }
    }
    const stopServerButton = (
      <Button
        variant="contained"
        color="primary"
        fullWidth
        disabled={isStopping}
        onClick={() => this.stopServer(engine)}
      >
        Stop server
      </Button>
    );

    return (
      <div className={classes.selServerInfoContainer}>
        <Grid container spacing={2}>
          <Grid xs={3} />
          <Grid item xs={6}>
            {serverEngineInfo}
            {stopServerButton}
          </Grid>
          <Grid xs={3} />
        </Grid>
      </div>
    );
  };

  _renderAvailableServers = () => {
    const { availableServers } = this.state;
    const {
      classes,
      selectedEngineIndex,
      enginesOptionsList,
      handleChangeOptions,
      user
    } = this.props;

    const handlePopoverOpen = (option, event) => {
      enginesOptionsList[ENGINES[selectedEngineIndex]][option].anchorEl =
        event.currentTarget;
    };

    const handlePopoverClose = option => {
      delete enginesOptionsList[ENGINES[selectedEngineIndex]][option].anchorEl;
    };

    return availableServers.map(server => {
      const servInfo = coreToKNode(selectedEngineIndex, server.cores);

      let engineOptions = enginesOptionsList[ENGINES[selectedEngineIndex]];

      const optionLabels = engineOptions ? Object.keys(engineOptions) : [];
      optionLabels.sort();

      return (
        <Grid item xs={12} sm={4} md={3} key={`Cores ${server.cores}`}>
          <Card className={classes.card}>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                {servInfo.caption}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Speed: <b>{servInfo.average}</b> kN/s
              </Typography>
              {optionLabels.length > 0 && <Divider />}

              <Grid container spacing={0} style={{ marginTop: 10 }}>
                {optionLabels.map(option => (
                  <Grid xs={12}>
                    {engineOptions[option].type === 'option' && (
                      <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-label">
                          <Grid container spacing={0}>
                            <Grid xs={10}>{option}</Grid>
                            <Grid xs={2}>
                              <InfoIcon
                                color="primary"
                                fontSize="small"
                                onMouseEnter={e => handlePopoverOpen(option, e)}
                                onMouseLeave={e =>
                                  handlePopoverClose(option, e)
                                }
                                style={{ marginTop: -2, marginLeft: 10 }}
                              />
                            </Grid>
                          </Grid>
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={engineOptions[option].options[0]}
                          onChange={e =>
                            handleChangeOptions(
                              e,
                              option,
                              ENGINES[selectedEngineIndex],
                              engineOptions[option].type
                            )
                          }
                          style={{ textAlign: 'left' }}
                        >
                          {engineOptions[option].options.map(opt => (
                            <MenuItem value={opt}>{opt}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                    {engineOptions[option].type === 'number' && (
                      <TextField
                        id="standard-number"
                        label={
                          <Grid container spacing={0}>
                            <Grid xs={10}>{option}</Grid>
                            <Grid xs={2}>
                              <InfoIcon
                                color="primary"
                                fontSize="small"
                                onMouseEnter={e => handlePopoverOpen(option, e)}
                                onMouseLeave={e =>
                                  handlePopoverClose(option, e)
                                }
                                style={{ marginTop: -2, marginLeft: 10 }}
                              />
                            </Grid>
                          </Grid>
                        }
                        type="number"
                        error={isNaN(
                          parseFloat(engineOptions[option].options[0])
                        )}
                        className={classes.formControl}
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          min: engineOptions[option].valid_range[0],
                          max: engineOptions[option].valid_range[1],
                          step: '0.1'
                        }}
                        margin="normal"
                        value={engineOptions[option].options[0]}
                        onChange={e =>
                          handleChangeOptions(
                            e,
                            option,
                            ENGINES[selectedEngineIndex],
                            engineOptions[option].type
                          )
                        }
                      />
                    )}
                    {engineOptions[option].type === 'boolean' && (
                      <FormControlLabel
                        className={classes.formControlLabel}
                        label={
                          <Grid container spacing={0}>
                            <Grid xs={10}>{option}</Grid>
                            <Grid xs={2}>
                              <InfoIcon
                                color="primary"
                                fontSize="small"
                                onMouseEnter={e => handlePopoverOpen(option, e)}
                                onMouseLeave={e =>
                                  handlePopoverClose(option, e)
                                }
                                style={{ marginTop: -2, marginLeft: 10 }}
                              />
                            </Grid>
                          </Grid>
                        }
                        labelPlacement="start"
                        control={
                          <Checkbox
                            checked={engineOptions[option].options[0]}
                            onChange={e =>
                              handleChangeOptions(
                                e,
                                option,
                                ENGINES[selectedEngineIndex],
                                engineOptions[option].type
                              )
                            }
                            value="checked"
                            color="primary"
                          />
                        }
                      />
                    )}
                    <Popover
                      id="mouse-over-popover"
                      className={classes.popover}
                      classes={{
                        paper: classes.paper
                      }}
                      open={
                        engineOptions[option].description &&
                          engineOptions[option].description.length > 0
                          ? Boolean(engineOptions[option].anchorEl)
                          : false
                      }
                      anchorEl={engineOptions[option].anchorEl}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                      }}
                      onClose={e => handlePopoverClose(option, e)}
                      disableRestoreFocus
                    >
                      <Typography>
                        {engineOptions[option].description}
                      </Typography>
                    </Popover>
                  </Grid>
                ))}
              </Grid>
              <Divider />
              <Typography variant="body1" style={{ marginTop: 20 }}>
                Price: <b>{server.price_per_minute} coins</b>/<small>min</small>
              </Typography>
            </CardContent>
            <CardActions>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                disabled={
                  !showAnalizeButton(
                    user,
                    server.cores,
                    server.price_per_minute
                  )
                }
                onClick={() =>
                  this.orderServer(server.cores, ENGINES[selectedEngineIndex])
                }
              >
                Order
              </Button>
            </CardActions>
          </Card>
        </Grid>
      );
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { selectedEngineIndex } = this.props;
    const { availableServersIntervalId, pingAliveIntervalId } = this.state;

    if (selectedEngineIndex !== nextProps.selectedEngineIndex) {
      clearInterval(availableServersIntervalId);
      clearInterval(pingAliveIntervalId);
      this.setState({ availableServers: [] });
      this.getAvailableServers(nextProps.selectedEngineIndex);
      this.pingAlive(ENGINES[nextProps.selectedEngineIndex]);
    }

    if (!nextProps.user) return;

    if (nextProps.user.server) {
      this.setState({ isOrdering: false });
    } else {
      this.setState({ isStopping: false });
    }
  }

  render() {
    const { classes, user } = this.props;
    const { isOrdering, isServerSyzygyOrdering } = this.state;

    let view = this._renderAvailableServers();
    if (isServerSyzygyOrdering && Object.keys(isServerSyzygyOrdering).length) {
      view = this._renderSyzygyMessage();
    } else if (isOrdering) {
      view = this._renderPreparingServer();
    } else if (user.server) {
      view = this._renderOrderedServerInfo();
    }

    return (
      <div className={classes.root}>
        <Grid container>{view}</Grid>
      </div>
    );
  }
}

EngineServers.propTypes = {
  selectedEngineIndex: PropTypes.number.isRequired
};

export default withStyles(styles)(EngineServers);
